import { FETCH } from 'API/fetch'
import { profileRoutes } from 'API/routes/profile'

export class Profile {
  async update (data) {
    const response = await FETCH('put', profileRoutes.update, data, null, false, true)
    return response
  }
}
